'use client';

import {useContext} from 'react';

import Vector from '@/components/elements/vector/Vector';
import {Theme} from '@/types/index';
import {SettingContext} from '@/context/Setting';

export default function ThemeToggle() {
  const [setting, setSetting] = useContext(SettingContext)!;
  const isLightTheme = setting.theme === Theme.Light;

  function onClick() {
    let theme = Theme.Light;
    let method: 'add' | 'remove' = 'remove';
    if (isLightTheme) {
      theme = Theme.Dark;
      method = 'add';
    }

    document.documentElement.classList[method](Theme.Dark);
    setSetting(state => ({...state, theme}));
  }

  return (
    <Vector
      name={isLightTheme ? 'HiMoon' : 'HiSun'}
      onClick={onClick}
      // Since the client's system theme cannot be determined during
      // the initial server-side render, the displayed icon may differ
      // from the client's actual system theme until hydration completes.
      svgProps={{suppressHydrationWarning: true}}
      hasRoundBorder
      hasFocus
    />
  );
}
